import type { IntervalSchedule } from '@/types/automationSteps.ts';

export const createDefaultSchedule = (): IntervalSchedule => ({
  kind: 'interval',
  every_minutes: 180,
  start_at: new Date(Math.ceil((Date.now() + 60_000) / 300_000) * 300_000).toISOString(),
});

export type ScheduleDraft = {
  every_minutes: string | number;
  start_at: string;
};

export function validateScheduleDraft(draft: ScheduleDraft): {
  schedule?: IntervalSchedule;
  intervalError?: string;
  startError?: string;
} {
  const everyMinutes = draft.every_minutes === '' ? NaN : Number(draft.every_minutes);
  const intervalError =
    !Number.isInteger(everyMinutes) || everyMinutes < 5 || everyMinutes > 525600 || everyMinutes % 5 !== 0
      ? 'Enter a whole number from 5 to 525600, in multiples of 5.'
      : undefined;

  const start = draft.start_at.trim();
  const parts = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})(?::(\d{2})(?:\.(\d{1,6}))?)?(Z|[+-]00:00)$/i.exec(start);
  let startError: string | undefined;
  let normalizedStart: string | undefined;
  if (!parts) {
    startError = 'Enter a UTC date and time, for example 2026-11-01T12:00:00Z.';
  } else if ((parts[3] && parts[3] !== '00') || (parts[4] && /[1-9]/.test(parts[4]))) {
    startError = 'Use a whole minute: seconds and fractional seconds must be zero.';
  } else {
    const minute = `${parts[1]}T${parts[2]}`;
    const date = new Date(`${minute}:00.000Z`);
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 16) !== minute || parts[1].startsWith('0000')) {
      startError = 'Enter a valid calendar date and time.';
    } else {
      normalizedStart = date.toISOString();
    }
  }

  return {
    intervalError,
    startError,
    ...(!intervalError && normalizedStart
      ? { schedule: { kind: 'interval' as const, every_minutes: everyMinutes, start_at: normalizedStart } }
      : {}),
  };
}
